export enum DigitalMediaEntityType {
    Persons = 1,
    Vehicle = 2,
    IncidentReport = 3,
    Charging = 4,
    Organizations = 5,
    Property = 6,
    Warning = 7,
    Narrative = 8,
    Violation = 9,
    Booking = 10,
    ArrestReport = 11,
    Affidavit = 12,
    DomesticViolence = 13,
    /** Mirrors DigitalMediaEntityType.Location in Cody.DigitalMedia.Utilities (10.0.1+). Join table is dbo.LocationMedia. */
    Location = 14,
    Unknown = 99
}